/* @flow */

import type { CombinedReducers } from '../../../../reducers';
import type { Dispatch } from '../../../../types/types';
import type { RequestResponseMethodDefinitionType } from '../../emitter';

import removeFromFavoriteList from '../deleteFavorite';
import getFavoriteList from '../favoriteList';

const deleteFavoriteList: (signal?: AbortSignal) => RequestResponseMethodDefinitionType =
  (list, signal) =>
  (dispatch: Dispatch, getState: () => CombinedReducers): Promise<void> => {
    const {
      ui: { favoriteList },
    } = getState();

    if (favoriteList === null) {
      return Promise.resolve();
    }

    const promises: Array<Promise<void>> = favoriteList.map((titId) => dispatch(removeFromFavoriteList(titId, signal, true)));
    return Promise.allSettled(promises).then(() => dispatch(getFavoriteList(signal)));
  };

export { deleteFavoriteList };
